import { Button, Grid, Typography } from "@mui/material";
import { Mode } from "../../components/ReadWriteTextField";

interface IProps {
  onSave?: () => void,
  onEdit?: () => void,
  onCancel?: () => void,
  message?: JSX.Element,
  canEdit: boolean,
  mode: Mode,
  header: string | JSX.Element,
}

export function SectionHead(props: IProps):JSX.Element {


  return <Grid container style={{marginBottom:"1rem"}}>
    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
    {typeof props.header === "string" ? 
        <Typography variant="h3" component="p">{props.header}</Typography> :
        props.header  
      }
    </Grid>
    <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>
      {props.message || ""}
    </Grid>
    <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{display:"flex", alignContent:"flex-end", alignItems:"flex-end", justifyContent:"flex-end"}}>
      <div style={{width:"200px"}}>
      {props.canEdit && <>
        {props.mode !== "edit" && <Button 
          variant="outlined" 
          color="primary"
          onClick={() => !!props.onEdit && props.onEdit()}
        >Edit</Button>}
        {props.mode === "edit" && <>
          <Button 
            variant="outlined" 
            color="warning"
            style={{marginRight:"1rem"}}
            onClick={() => !!props.onCancel && props.onCancel()}
          >Cancel</Button>
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => !!props.onSave && props.onSave()}
          >Save</Button>
        </>}
      </>}
      </div>
    </Grid>
  </Grid>
}